// tiny (any variant) is the worst whisper model for phantom output on near-silent audio.
// vad.ts should catch most of it before we ever call transcribe(), but this
// is the second line of defense against known phantom phrases that slip
// through (e.g. a short burst of room noise that still trips the VAD gate).

const KNOWN_HALLUCINATIONS = [
  "thank you",
  "thanks for watching",
  "[blank_audio]",
  "(blank audio)",
  "subtitles by",
  "amara.org",
  "please subscribe",
  "you",
  ".",
  "",
];

function normalize(text: string): string {
  return text.trim().toLowerCase().replace(/[.!?]+$/g, "");
}

export function looksLikeHallucination(text: string): boolean {
  const normalized = normalize(text);
  if (KNOWN_HALLUCINATIONS.includes(normalized)) return true;

  // A single word/phrase repeated back-to-back with nothing else — another
  // classic tiny failure mode on near-silent input.
  const words = normalized.split(/\s+/).filter(Boolean);
  if (words.length >= 4) {
    const unique = new Set(words);
    if (unique.size === 1) return true;
  }

  return false;
}
